import script from "./AdminFAQs.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFAQs.vue?vue&type=script&setup=true&lang=js"

import "./AdminFAQs.vue?vue&type=style&index=0&id=5af4f050&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af4f050"]])

export default __exports__